<template>
<div v-if="!getHideExpandBtn()" class="collapse-btn" :class="{expand: expand}" @click="expand = !expand">
  <div class="btn-text">{{ expand ? '收起' : '展开' }}</div>
  <div class="arrow-icon"></div>
</div>
</template>

<script>
export default {
  name: '',
  components: {},
  inject: ['getExpand', 'setExpand', 'getHideExpandBtn'],
  props: {},
  data() {
    return {};
  },
  computed: {
    expand: {
      get() {
        return this.getExpand();
      },
      set(value) {
        return this.setExpand(value);
      },
    },
  },
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {},
};
</script>

<style scoped lang="less">
.collapse-btn{
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  .btn-text{
    color: #91999F;
    font-size: 14px;
  }
  .arrow-icon{
    width: 12px;
    height: 12px;
    margin-left: 4px;
    transition: all 0.15s;
    background: url(../../../assets/imgs/product-detail/icon-arrow-down.png) no-repeat center / 100% 100%;
  }
  &.expand{
    .arrow-icon{
      transform: rotate(180deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/collapse/collapse-btn.vue